import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerPaymentCharterDetails } from 'anchor-shared/lib/model/interface/depostitInterfaces';
import { VesselRate } from 'anchor-shared/lib/model/entity/vessel-rate';
import { VesselRateCalculationService } from '../../../../core/services/vessel-rate-calculation-service';
import { getRateNameForCustomer } from 'anchor-shared/lib/service/pure-functions/get-vessel-rate-name';
import { getAddOnCost } from 'anchor-shared/lib/service/pure-functions/charter-pricing/charter-pricing-helper';
import { AddOn } from 'anchor-shared/lib/model/entity/addOn';
@Component({
  selector: 'app-customer-pricing-dialog',
  templateUrl: './customer-pricing-dialog.component.html',
  styleUrls: ['./customer-pricing-dialog.component.scss'],
})
export class CustomerPricingDialogComponent implements OnInit {
  public getRateNameForCustomer = getRateNameForCustomer;
  charterDetails: CustomerPaymentCharterDetails;
  addOns: AddOn[];

  constructor(
    public dialogRef: MatDialogRef<CustomerPricingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private calcService: VesselRateCalculationService,
  ) {}

  ngOnInit() {
    this.charterDetails = this.data.charterDetails;
    this.initAddOns();
  }

  initAddOns() {
    this.addOns = this.charterDetails.pricingMetaData?.addOns?.map((addOn) => {
      return { ...addOn, markupPrice: getAddOnCost(addOn, true) };
    });
  }

  getVesselRateTotal(
    rates: VesselRate[],
    includeServicesAndDiscounts = false,
  ): number {
    let rateTotal = this.calcService.getVesselRateTotal(
      rates,
      this.charterDetails.boatCaptCrewTotal,
      getDurationTypeForCalcService(this.charterDetails.charterDuration),
      this.charterDetails.charterDuration,
      this.charterDetails.fuelIncluded,
    );
    rateTotal += this.charterDetails.depositAmount;
    if (includeServicesAndDiscounts) {
      return (
        rateTotal +
        this.charterDetails.serviceTotal -
        this.charterDetails.discountTotal -
        this.charterDetails.promoCodeTotal
      );
    }
    return rateTotal;
  }

  getVesselRateTax(rates: VesselRate[]): number {
    return this.calcService.getVesselRateTax(
      rates,
      getDurationTypeForCalcService(this.charterDetails.charterDuration),
      this.charterDetails.charterDuration,
    );
  }

  getFuelRate(rates: VesselRate[]): number {
    const rate = this.calcService.getFuelIncludedRate(rates);
    return this.calculateVesselRate(rate);
  }

  calculateVesselRate(rate: VesselRate): number {
    return this.calcService.calculateVesselRate(
      rate,
      getDurationTypeForCalcService(this.charterDetails.charterDuration),
      this.charterDetails.charterDuration,
      true,
    );
  }

  isCustomRate(rate: VesselRate): boolean {
    return this.calcService.isCustomRate(rate);
  }
}

export function getDurationTypeForCalcService(duration: number): 0 | 4 | 8 {
  let returnHours: 0 | 4 | 8 = null;
  switch (duration) {
    case 4:
      returnHours = 4;
      break;
    case 8:
      returnHours = 8;
      break;
    default:
      returnHours = 0;
      break;
  }
  return returnHours;
}
